export default {
    props: ["activity", "showDropdown"],
    data () {
        return {
            menuIsOpen: false,
        };
    },
    computed: {
        dateCellSize () {
            if (this.notSmallScreen !== null) {
                return this.notSmallScreen === true ? "120px" : "30px";
            } else {
                return "120px";
            }
        },

        contentMargin () {
            if (this.notSmallScreen !== null) {
                return this.notSmallScreen === true ? "mr-120" : "mr-4";
            } else {
                return "mr-120";
            }
        }

    },

    methods: {
        editActivity () {
            this.$emit("edit-activity", this.activity);
        },

        deleteActivity () {
            this.$emit("delete-activity", this.activity);
        },

        sendSmsNotification () {
            this.$emit("notify-sms", this.activity);
        },

        sendEmailNotification () {
            this.$emit("notify-email", this.activity);
        },

        closeMenu () {
            this.menuIsOpen = false;
        }
    }
};
